/* __next_internal_client_entry_do_not_use__ CategoryRouter,CategoryRouterBase auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Switch } from "@faire/web--source/ui/routing/Switch";
import { Route } from "@faire/web-api--source/Route";
import { props as c1CategoryRouteProps } from "@faire/web-api--source/routes/category/c1CategoryUrlId";
import { props as c1CategoryBrandValueRouteProps } from "@faire/web-api--source/routes/category/c1CategoryUrlId/brand-value/brandValue";
import { props as c2CategoryRouteProps } from "@faire/web-api--source/routes/category/c1CategoryUrlId/subcategory/c2CategoryUrlId";
import { props as c2CategoryBrandValueRouteProps } from "@faire/web-api--source/routes/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/brand-value/brandValue";
import { props as c3CategoryRouteProps } from "@faire/web-api--source/routes/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId";
import { props as c3CategoryBrandValueRouteProps } from "@faire/web-api--source/routes/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/brand-value/brandValue";
import { props as c4CategoryRouteProps } from "@faire/web-api--source/routes/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/c4CategoryUrlId";
import { props as c5CategoryRouteProps } from "@faire/web-api--source/routes/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/c4CategoryUrlId/c5CategoryUrlId";
import { props as c6CategoryRouteProps } from "@faire/web-api--source/routes/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/c4CategoryUrlId/c5CategoryUrlId/c6CategoryUrlId";
import { props as c1CategoryShowroomRouteProps } from "@faire/web-api--source/routes/category/Showroom";
import { props as c1SuppliersRouteProps } from "@faire/web-api--source/routes/suppliers/c1SuppliersUrlId";
import { props as c1SuppliersBrandValueRouteProps } from "@faire/web-api--source/routes/suppliers/c1SuppliersUrlId/brand-value/brandValue";
import React, { Suspense } from "react";
import { isLoggedInRetailerOrBrandPreview, useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { useCategoryStore } from "@faire/retailer/stores/domain/CategoryStore";
import { LoggedInCategoryPageLoadingSkeleton } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/CategoryPageLoadingSkeleton/LoggedInCategoryPageLoadingSkeleton";
import { LoggedOutCategoryPageLoadingSkeleton } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/CategoryPageLoadingSkeleton/LoggedOutCategoryPageLoadingSkeleton";
import { CategoryPageRoot } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/CategoryPageRoot";
import { LazyShowroom } from "@faire/retailer/views/category/Showroom/LazyShowroom";
var nLevelCategoryRoutes = function(includeSuppliersRoutes) {
    return(// solely for /suppliers/All Brands/brand-value/{brandValue}
    // solely for /suppliers/All Brands
    _to_consumable_array(includeSuppliersRoutes ? [
        c1SuppliersBrandValueRouteProps,
        c1SuppliersRouteProps
    ] : []).concat([
        c3CategoryBrandValueRouteProps,
        c2CategoryBrandValueRouteProps,
        c1CategoryBrandValueRouteProps,
        c6CategoryRouteProps,
        c5CategoryRouteProps,
        c4CategoryRouteProps,
        c3CategoryRouteProps,
        c2CategoryRouteProps,
        c1CategoryRouteProps
    ]));
};
export var CategoryRouter = function() {
    return /*#__PURE__*/ _jsx(CategoryRouterBase, {
        Component: CategoryPageRoot
    });
};
export var CategoryRouterBase = function(param) {
    var Component = param.Component;
    var isSSR = useIsSSR();
    var categoriesLoading = useCategoryStore().categoriesLoading;
    var isLoggedInRetailer = useIsLoggedInRetailer();
    if (isSSR || categoriesLoading) {
        if (!isLoggedInRetailerOrBrandPreview()) {
            return /*#__PURE__*/ _jsx(LoggedOutCategoryPageLoadingSkeleton, {});
        }
        return /*#__PURE__*/ _jsx(LoggedInCategoryPageLoadingSkeleton, {});
    }
    var categoryRoutes = nLevelCategoryRoutes(isLoggedInRetailer);
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/ _jsxs(Switch, {
            children: [
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, c1CategoryShowroomRouteProps), {
                    exact: true,
                    component: LazyShowroom
                })),
                categoryRoutes.map(function(route) {
                    return /*#__PURE__*/ _createElement(Route, _object_spread_props(_object_spread({}, route), {
                        exact: true,
                        key: route.path,
                        component: Component
                    }));
                })
            ]
        })
    });
};
